"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundImage = void 0;
var React = __importStar(require("react"));
var BackgroundContext_1 = require("./BackgroundContext");
var BackgroundImage = function (_a) {
    var src = _a.src, transition = _a.transition, children = _a.children, _b = _a.style, styleProp = _b === void 0 ? {} : _b, otherProps = __rest(_a, ["src", "transition", "children", "style"]);
    var _c = React.useContext(BackgroundContext_1.BackgroundContext), bgImage = _c.bgImage, setBgImage = _c.setBgImage, prevBgImage = _c.prevBgImage, loaded = _c.loaded, contextStyle = _c.style;
    var style = __assign({ transition: transition ? '550ms' : 'none' }, styleProp);
    React.useEffect(function () {
        var isMounted = true;
        isMounted && src && setBgImage(src);
        return function () {
            isMounted = false;
        };
    }, [src]);
    if (bgImage && loaded) {
        style.backgroundImage = "url(".concat(bgImage, ")");
    }
    else if (prevBgImage) {
        style.backgroundImage = "url(".concat(prevBgImage, ")");
    }
    return (React.createElement("div", __assign({ style: Object.assign({}, contextStyle, style) }, otherProps), children));
};
exports.BackgroundImage = BackgroundImage;
//# sourceMappingURL=BackgroundImage.js.map